// React
import React from 'react';

// Component
export default class AppRouter extends React.Component {

    constructor($props) {
        // Props
        super($props);
        // State
        this.state = {
            initialized: false
        };
        // References
        this.$self = React.createRef();
    }

    componentDidMount() {
        
        this.setState({
            initialized: true
        });
        
    }

    render() {

        return (
            <div ref={this.$self} className={"cta__bar "+(this.state.initialized ? 'active' : '')}>
                <a className="btn" href="/contact/">Get Started</a>
            </div>
        );

    }

}


// WEBPACK FOOTER //
// ./build/tbo-crm/js/Component/Router.jsx